import { useMutation } from '@apollo/react-hooks';
import { SEND_MESSAGE_TO_COMPAIGN } from '../../graphql/compaign/mutation';
import {
  SendMessageToCompaign,
  SendMessageToCompaignVariables,
} from '../../graphql/compaign/types/SendMessageToCompaign';

export const useSendMessageToCompaign = () => {
  return useMutation<SendMessageToCompaign, SendMessageToCompaignVariables>(
    SEND_MESSAGE_TO_COMPAIGN,
    {
      onError: () => {
        // TODO: implement me
      },
    },
  );
};
